import React from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md';
import PostRating from './PostRating';

dayjs.extend(relativeTime);

export default function ProductReviews({ reviewData, layout, color = '#FFC107' }) {
  const approvedReviews = reviewData.filter((review) => review.ModerationStatus === 'APPROVED');

  return (
    <>
      <style>{`
    .review-card {
        padding: 16px;
        position: relative;
        max-width: 600px;
        margin: auto;
        background-color: #fff;
        border-radius: 8px;
        }
    .nav-buttons {
        position: absolute;
        top: 15px;
        right: 0;
        display: flex;
        gap: 2px;
        z-index: 10;
        }
    .reviewer-name {
        font-weight: bold;
        }
    .review-text {
        margin: 10px 0;
        }
    .review-footer {
        font-size: 0.85rem;
        color: #555;
        border-top: 1px solid #eee;
        padding-top: 8px;
    }
`}</style>
      <idk-div class="zid-relative" id="product_review_container">
        <Swiper
          slidesPerView={1}
          spaceBetween={20}
          navigation={{
            nextEl: '.slider-button-next',
            prevEl: '.slider-button-prev',
          }}
          modules={[Navigation]}
        >
          {approvedReviews.map((review, index) => {
            if (review.ReviewText) {
              return (
                <SwiperSlide key={index}>
                  <idk-div class="review-card">
                    <idk-div class="nav-buttons">
                      <MdKeyboardArrowLeft
                        className="slider-button-prev"
                        color={layout?.sliderSettings?.arrowColor}
                        fontSize={24}
                      />
                      <MdKeyboardArrowRight
                        className="slider-button-next"
                        color={layout?.sliderSettings?.arrowColor}
                        fontSize={24}
                      />
                    </idk-div>
                    <idk-div>
                      <idk-p class="reviewer-name zid-flex zid-items-center zid-gap-2">
                        {review.UserNickname}{' '}
                        <PostRating size={15} hideNumbers={true} rating={review.Rating} totalUsers={0} color={color} />{' '}
                      </idk-p>
                      {/* <idk-p class="zid-flex zid-items-center zid-gap-1">
                      <MdVerified /> Verified Customer
                    </idk-p> */}
                      <idk-p class="review-text">{review.ReviewText}</idk-p>
                      {/* <idk-p class="review-text">
                      Was this review helpful? <a href="#">Yes</a> <a href="#">Report</a>
                    </idk-p> */}
                    </idk-div>

                    <idk-div class="review-footer">
                      <idk-p class="zid-text-center">
                        {review.UserLocation ? `${review.UserLocation}, ` : ''}
                        {dayjs(review.SubmissionTime).fromNow()}
                      </idk-p>
                    </idk-div>
                  </idk-div>
                </SwiperSlide>
              );
            }
          })}
        </Swiper>
      </idk-div>
    </>
  );
}
